"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("./styles");
var LightContext_1 = __importDefault(require("../../Context/LightContext"));
var Bubble = function (_a) {
    var children = _a.children, position = _a.position;
    var context = react_1.useContext(LightContext_1.default);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.BubbleStyles, { position: position, isOn: context.lightOn },
            react_1.default.createElement(styles_1.Text, null, children)),
        react_1.default.createElement(styles_1.BubbleStyles, { position: position, isOn: context.lightOn, bgColor: "#97b9d0", style: { opacity: context.lightOn ? 0 : 1 } },
            react_1.default.createElement(styles_1.Text, null, children))));
};
exports.default = Bubble;
